import React, { useContext, useState } from 'react';

// Styles & Assets
import styles from './AlertPoll.module.css';
import { SlBell } from 'react-icons/sl';

// Context
import ScoresContext from '../../../context/ScoresContext';

// Components
import Modal from '../../UI/Modal/Modal';

// Language
import { Poll } from '../../../interfaces/Poll';
import ScoreRulesView from '../../Scores/ScoreRulesView/ScoreRulesView';
import AlertRulesView from '../../Scores/AlertRulesView/AlertRulesView';
import { useTranslation } from 'react-i18next';

// Interface
interface Props {
    poll: Poll
}

const AlertPoll: React.FC<Props> = ({ poll }) => {

    const { t } = useTranslation();

    const [showModal, setShowModal] = useState(false);

    const { scores } = useContext(ScoresContext);

    const scoreRules = scores?.find(s => s.inquiry_id === poll.id)?.score_rules;

    const inquiryAlerts = (poll.inquiry_alerts || []).map(alert => ({
        ...alert, 
        inquiry_question_name: poll.questions?.find(q => q.id === alert.inquiry_question_id)?.description || ''
    }));

    return (
        <>
            {((scoreRules && scoreRules?.length > 0) || (poll.inquiry_alerts && poll.inquiry_alerts.length > 0)) &&
                <button className={styles.bell} onClick={() => setShowModal(true)}>
                    <SlBell />
                </button>
            }
            <Modal show={showModal} setShowModal={setShowModal}>
                <div className={`dialog ${styles.dialog}`}>
                    <h1 className='dialogTitle'>{t('scores_and_alerts')}</h1>
                    <ScoreRulesView scoreRules={scoreRules || []} />
                    {(scoreRules && scoreRules?.length > 0) && poll.inquiry_alerts && poll.inquiry_alerts.length > 0 &&
                        <hr className={styles.horizontalLine} />
                    }
                    <AlertRulesView alerts={inquiryAlerts} />
                    <div className={styles.buttonContainer}>
                        <button onClick={() => setShowModal(false)} className={`${styles.btnClose} button`}>{t('close')}</button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default AlertPoll;